import { useSelector } from 'react-redux'
import { IBaseMediaItem } from 'types/media'
import { editorSelectors } from 'store/features/editor/selectors'
import { secondsToPixels } from 'utils/timeline'
import { useTrackHeight } from 'hooks/useTrackHeight'
import * as Styled from './styled'
import { DEFAULT_MEDIA_DURATION } from 'consts'

interface IProps {
  item: IBaseMediaItem
}

const DraggingItemPlaceholder: React.FC<IProps> = ({ item }) => {
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const height = useTrackHeight()
  const width = secondsToPixels(
    Math.min(DEFAULT_MEDIA_DURATION, item.duration),
    timelineRulerSliceDuration
  )

  const isVideo = item.type === 'video' || item.type === 'aiVideo'
  const imageUrl = isVideo
    ? item.thumbnail || item.imageUrl
    : item.thumbnail || item.path

  return (
    <Styled.Wrapper $width={width} $height={height}>
      {imageUrl ? <Styled.MediaImg src={imageUrl} alt="" /> : null}
    </Styled.Wrapper>
  )
}

export default DraggingItemPlaceholder
